import { FC } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { allLanguage } from "../../utils/languages";
import { setLanguage, useLang } from "../../i18n/Metronici18n";
import { useAuth } from "../../utils/useAuth";

const HeaderUserMenu: FC = () => {
    const { currentUser, logout } = useAuth();
    const { formatMessage } = useIntl();
    const localLang = useLang();
    const currentLang = allLanguage.find((el) => el.lang == localLang) || allLanguage[0];

    function onLanguageSelect(language: string) {
        setLanguage(language);
    }

    return (
        <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
            data-kt-menu="true"
        >
            <div className="menu-item my-2 px-3">
                <div className="menu-content d-flex align-items-center px-3">
                    <div className="d-flex flex-column">
                        <div className="fw-bolder d-flex align-items-center fs-5 ">
                            <span className="w-250px text-truncate">
                                {currentUser?.firstName} {currentUser?.lastName}
                            </span>
                        </div>
                        <div className="fw-bold text-muted text-hover-primary fs-7 w-250px text-truncate">
                            {currentUser?.email}
                        </div>
                    </div>
                </div>
            </div>

            <div className="separator "></div>

            <div className="menu-item px-5">
                <Link
                    to={"user/profile"}
                    className="menu-link px-5 py-2 mb-1"
                    style={{ color: "#333" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#333")}
                >
                    {formatMessage({ id: "layout.profile.profile" })}
                </Link>
            </div>

            {/* multi lang menu */}
            <div
                className="menu-item my-2 px-5"
                data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
                data-kt-menu-placement="right-end"
                data-kt-menu-offset="-15px, 0"
            >
                <a className="menu-link px-5 py-2 mb-2">
                    <span
                        className="menu-title position-relative"
                        style={{ color: "#333" }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "#333")}
                    >
                        {formatMessage({ id: "layout.profile.language" })}
                        <span className="fs-8 rounded bg-light text-dark px-3 py-2 position-absolute translate-middle-y top-50 end-0">
                            {formatMessage({ id: `layout.profile.${currentLang.name}` })}
                            <img
                                className="w-15px h-15px rounded-1 ms-2"
                                src={currentLang.flag}
                                alt={currentLang.flag}
                            />
                        </span>
                    </span>
                </a>

                <div className="menu-sub  my-2 menu-sub-dropdown w-175px py-5">
                    {allLanguage.map((language, index) => (
                        <div key={index} className="menu-item my-1 px-5">
                            <a
                                className="menu-link d-flex px-5 py-2"
                                style={{ color: "#333" }}
                                onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                                onMouseLeave={(e) => (e.currentTarget.style.color = "#333")}
                                onClick={() => onLanguageSelect(language.lang)}
                            >
                                <span className="symbol symbol-20px me-4">
                                    <img
                                        className="rounded-1"
                                        src={language.flag}
                                        alt={language.flag}
                                    />
                                </span>
                                {formatMessage({ id: `layout.profile.${language.name}` })}
                            </a>
                        </div>
                    ))}
                </div>
            </div>

            {/* end multi lang menu */}

            <div className="menu-item px-5">
                <a
                    onClick={logout}
                    className="menu-link px-5 mb-5 py-2"
                    style={{ color: "#333" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#333")}
                >
                    {formatMessage({ id: "layout.profile.signout" })}
                </a>
            </div>
        </div>
    );
};

export { HeaderUserMenu };
